import { lazy } from 'react';

export const LazyGettingStartedPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--getting-started-page" */ './getting-started-page'
    ),
);
